import { SVG, getDefaultHeight } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const ExitFullscreenIcon = ({
  color = "currentColor",
  ...svgProps
}: Props): React.JSX.Element => {
  return (
    <SVG
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 24)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="M1 15.7h7.3V23M23 8.3h-7.3V1m0 22v-7.3H23M8.3 1v7.3H1" />
    </SVG>
  );
};
